import React from 'react';
import { Loader } from 'lucide-react';

interface SpinnerProps {
  className?: string;
  size?: number;
  showText?: boolean;
  text?: string;
  containerClassName?: string;
}

export const Spinner: React.FC<SpinnerProps> = ({ 
  className = 'text-primary', 
  size = 40, 
  showText = true,
  text = 'Loading ...',
  containerClassName = ''
}) => {
  return (
    <div className={`flex items-center justify-center h-full w-full ${containerClassName}`}>
      <div className="text-center">
        <Loader 
          size={size} 
          className={`animate-spin mx-auto mb-4 ${className}`}
        />
        {showText && <p className="text-gray-600">{text}</p>}
      </div>
    </div>
  );
};

export default Spinner;